import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOrdenType,
  ActiveOrdenType,
  InactiveOrdentype,
} from "../../../store/ordentype-store/ordentype-actions";
import { useEffect } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import Loading from "../../../components/UI/Loading";
const OrdenTypeDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ordenType = useSelector((state) => state.ordenType.ordenType);
  const auth = useSelector((state) => state.auth);
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    dispatch(GetOrdenType(param.ordenTypeId, auth.UserInfo.email));
  }, [param.ordenTypeId, auth, dispatch]);

  const activeHandler = () => {
    dispatch(ActiveOrdenType(param.ordenTypeId, auth.UserInfo.email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveOrdentype(param.ordenTypeId, auth.UserInfo.email));
  };
  let activeSuspend;
  if (auth.roles !== undefined && auth.roles.includes("ordentype.active")) {
    activeSuspend = (
      <Button
        rounded
        text
        raised
        style={{ backgroundColor: "#fff", marginLeft: "1%" }}
        label="Activar"
        className="p-button-success"
        onClick={activeHandler}
        icon={
          notification && notification.status === "pending"
            ? "pi pi-spin pi-spinner"
            : "pi pi-check"
        }
        disabled={notification && notification.status === "pending"}
      />
    );
  }
  if (ordenType.status) {
    if (auth.roles !== undefined && auth.roles.includes("ordentype.inactive")) {
      activeSuspend = (
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", marginLeft: "1%" }}
          label="Suspender"
          className="p-button-warning"
          onClick={inactiveHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-times"
          }
          disabled={notification && notification.status === "pending"}
        />
      );
    }
  }

  return (
    <>
      {(ordenType.id === undefined || ordenType.id === 0) &&  <Loading visible={true} />}
      {ordenType.id !== undefined && ordenType.id > 0 && (
        <Card
          style={{
            backgroundColor: "#183462",
            marginLeft: "1%",
            marginTop: "8px",
            boxShadow: "none",
            width: "99%",
            border: "solid #326fd1",
          }}
        >
          <div
            className="user-info text-center"
            style={{ borderBottom: "solid #fff", paddingBottom: "4px" }}
          >
            <h2
              id="header"
              className="mb-2"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              {ordenType.name.toUpperCase()}
            </h2>
            <span
              className="badge bg-label-secondary"
              style={{
                fontSize: "large",
                color: "lightskyblue",
                fontWeight: "bold",
              }}
            >
              tipo de orden
            </span>
          </div>
          <div className="formgrid grid">
            <div className="field col-12 md:col-3">
              <>
                <label style={{ color: "#fff", fontSize: "large" }}>
                  Descripción:{" "}
                </label>
                <label
                  style={{
                    color: "lightskyblue",
                    marginLeft: "1%",
                    fontSize: "large",
                  }}
                >
                  {" "}
                  {ordenType.description}
                </label>
              </>
            </div>
            <div className="field col-12 md:col-12 mt-3">
              <Button
                rounded
                text
                raised
                style={{ backgroundColor: "#fff" }}
                label="Regresar"
                icon="pi pi-arrow-left"
                className="p-button-danger"
                onClick={() => {
                  navigate("/orden/types");
                }}
              />
              {auth.roles !== undefined &&
                auth.roles.includes("ordentype.edit") && (
                  <Button
                    rounded
                    text
                    raised
                    style={{ backgroundColor: "#fff", marginLeft: "1%" }}
                    label="Editar"
                    className="p-button-primary"
                    icon="pi pi-file-edit"
                    onClick={() => {
                      navigate(`/orden/type/edit/${param.ordenTypeId}`);
                    }}
                  />
                )}
              {activeSuspend}
            </div>
          </div>
        </Card>
      )}
    </>
  );
};
export default OrdenTypeDetail;
